var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":("0 0 " + _vm.svgWidth + " " + _vm.svgHeight),"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":("#svg__" + _vm.icon),"fill":_vm.currentFill}})])}
var staticRenderFns = []

export { render, staticRenderFns }